import useTranslation from 'hooks/useTranslation'
import { useSelector } from 'react-redux'
import Loading from 'components/Loading'
import { selectConfig } from 'appSlice'
import Error from 'components/Error'
import { useState } from 'react'

const basicData = [{
  question: 'whatDoesMagMean',
  answer: 'warehouse',
}, {
  question: 'whatIsTheAppFor',
  answer: 'forRentingAndManagingMags',
}, {
  question: 'canICancelMyRentalBeforeTheDeadline',
  answer: 'yesYouCanCancelYourRentalAtAnyTime',
}]

const FaqItem = ({ question, answer, title, content }) => {
  const [selected, select] = useState(false)
  const { t } = useTranslation('help')

  return (
    <div className='list__item'>
      <div
        className='group'
        onClick={() => { select(!selected) }}>
        <p>{title || t(question)}</p>
        <div className={`item__arrow --${selected ? 'down' : 'up'}`}></div>
      </div>

      {selected && <div>
        {content
          ? <div dangerouslySetInnerHTML={{ __html: content }} />
          : <i>{t(answer)}</i>}
      </div>}
    </div>
  )
}

const Faq = ({ isDesktop = false }) => {
  const config = useSelector(selectConfig)
  const data = config?.faq || basicData
  const { t } = useTranslation('account')
  return (
    <div className='help__faq'>
      <h4>FAQ</h4>
      <div className='faq__list'>
        {config
          ? data?.length > 0
            ? data.map((e, i) => <FaqItem {...e} key={i} />)
            : <Error
              staticPos={!isDesktop}
              text={t('noItems')}
            />
          : <Loading middleOfPage={isDesktop} />}
      </div>
    </div>
  )
}

export default Faq